import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Chip,
  IconButton, 
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Add, Delete, Edit } from "@mui/icons-material";
import { getAllZones, saveZone, updateZone, deleteZone } from '../service/zoneService';
import warehouseService from '../service/warehouseService'; 


const ZoneManager = () => {
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editingZone, setEditingZone] = useState(null);
   const [warehouses, setWarehouses] = useState([]);

  const [formData, setFormData] = useState({
    zoneName: "",
    sector: "",
    city: "",
    state: "",
    country: "",
    deliverySlaMinutes: 120,
    maxVendorDistanceKm: 8,
    pincodes: [],
    warehouseIds: [],
  });

  useEffect(() => {
    fetchZones();
    fetchWarehouses();
  }, []);

  const fetchZones = async () => {
    setLoading(true);
    try {
      const res = await getAllZones(); //axiosInstance.get("/api/zones");
      setZones(res.data);
    } catch (err) {
      console.error("Error fetching zones:", err);
    }
    setLoading(false);
  };
  
    const fetchWarehouses = async () => {
    try {
       const res =  await warehouseService.fetchSupplierBasicWarehouse();
    setWarehouses(res);
    } catch (err) {
      console.error("Error fetching zones:", err);
    }
  };

  const handleOpen = (zone) => {
    if (zone) {
      setEditingZone(zone);
 
    setFormData({
      ...zone,
      warehouseIds: zone.warehouseIds,
      // You might also want to explicitly remove the 'warehouses' array 
      // if your DTO doesn't expect it, but this is optional for a temporary state object.
      // warehouses: undefined 
    });
    } else {
      setEditingZone(null);
      setFormData({
        zoneName: "",
        sector: "",
        city: "",
        state: "",
        country: "",
        deliverySlaMinutes: 120,
        maxVendorDistanceKm: 8,
        pincodes: [],
        warehouseIds: [],
      });
    }
    setOpen(true);
  };
const handleChangeWarehouse = (event) => {
    const {
      target: { value },
    } = event;
    setFormData({
      ...formData,
      warehouseIds: typeof value === "string" ? value.split(",") : value,
    });
  };
  const handleClose = () => setOpen(false);

  const handleSave = async () => {
    try {
      if (editingZone) {
        await updateZone(editingZone.id,formData );//axiosInstance.put(`/api/zones/${editingZone.id}`, formData);
      } else {
        await saveZone(formData); //axiosInstance.post("/api/zones", formData);
      }
      fetchZones();
      handleClose();
    } catch (err) {
      console.error("Error saving zone:", err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this zone?")) return;
    try {
      await deleteZone(id); //axiosInstance.delete(`/api/zones/${id}`);
      fetchZones();
    } catch (err) {
      console.error("Error deleting zone:", err);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "zoneName", headerName: "Zone Name", width: 300 },
    { field: "sector", headerName: "Sector", width: 120 },
    { field: "city", headerName: "City", width: 120 },
    { field: "state", headerName: "State", width: 120 },
    { field: "country", headerName: "Country", width: 120 },
    {
      field: "pincodes",
      headerName: "Pincodes",
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
          {params.value?.map((p) => (
            <Chip key={p.id} label={p.pincode} size="small" />
          ))}
        </Box>
      ),
    },
      { field: "deliverySlaMinutes", headerName: "SLA (min)", width: 10 },
    { field: "maxVendorDistanceKm", headerName: "Max Distance (km)", width: 30 },
    {
      field: "actions",
      headerName: "Actions",
      width: 160,
      renderCell: (params) => (
        <Box>
          <IconButton onClick={() => handleOpen(params.row)}>
            <Edit />
          </IconButton>
          <IconButton onClick={() => handleDelete(params.row.id)}>
            <Delete color="error" />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Zone Management
      </Typography>
      <Button
        startIcon={<Add />}
        variant="contained"
        onClick={() => handleOpen()}
        sx={{ mb: 2 }}
      >
        Add Zone
      </Button>
      <div style={{ height: 500, width: "100%" }}>
        <DataGrid
          rows={zones}
          columns={columns}
          loading={loading}
          getRowId={(row) => row.id}
          pageSizeOptions={[5, 10, 20]}
        />
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>{editingZone ? "Edit Zone" : "Create Zone"}</DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
            label="Zone Name"
            value={formData.zoneName}
            onChange={(e) => setFormData({ ...formData, zoneName: e.target.value })}
            fullWidth
          />
          <TextField
            label="Sector"
            value={formData.sector}
            onChange={(e) => setFormData({ ...formData, sector: e.target.value })}
            fullWidth
          />
          <TextField
            label="City"
            value={formData.city}
            onChange={(e) => setFormData({ ...formData, city: e.target.value })}
            fullWidth
          />
          <TextField
            label="State"
            value={formData.state}
            onChange={(e) => setFormData({ ...formData, state: e.target.value })}
            fullWidth
          />
          <TextField
            label="Country"
            value={formData.country}
            onChange={(e) => setFormData({ ...formData, country: e.target.value })}
            fullWidth
          />
          <TextField
            type="number"
            label="Delivery SLA Minutes"
            value={formData.deliverySlaMinutes}
            onChange={(e) =>
              setFormData({ ...formData, deliverySlaMinutes: Number(e.target.value) })
            }
            fullWidth
          />
          <TextField
            type="number"
            label="Max Vendor Distance (km)"
            value={formData.maxVendorDistanceKm}
            onChange={(e) =>
              setFormData({ ...formData, maxVendorDistanceKm: Number(e.target.value) })
            }
            fullWidth
          />
          {/* TODO: Add UI for Pincodes + WarehouseIds management */}
           <FormControl fullWidth>
          <InputLabel>Warehouses</InputLabel>
          <Select
            multiple
            value={formData.warehouseIds}
            onChange={handleChangeWarehouse}
            input={<OutlinedInput label="Warehouses" />}
            renderValue={(selected) => {
              const selectedNames = warehouses
                .filter((w) => selected.includes(w.warehouseId))
                .map((w) => w.name)
                .join(", ");
              return selectedNames || "Select Warehouses";
            }}
          >
            {warehouses.map((w) => (
              <MenuItem key={w.warehouseId} value={w.warehouseId}>
                <Checkbox checked={formData.warehouseIds.includes(w.warehouseId)} />
                <ListItemText primary={w.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ZoneManager;